import { i18n } from 'i18n';
import IdField from 'modules/shared/fields/idField';
import DateTimeField from 'modules/shared/fields/dateTimeField';
import DateTimeRangeField from 'modules/shared/fields/dateTimeRangeField';
import StringField from 'modules/shared/fields/stringField';
import BooleanField from 'modules/shared/fields/booleanField';
import RelationToOneField from 'modules/shared/fields/relationToOneField';
import JsonField from 'modules/shared/fields/jsonField';
import RelationToManyField from 'modules/shared/fields/relationToManyField';
import { message } from 'antd';
import EnumeratorField from 'modules/shared/fields/enumeratorField';

function label(name) {
  return i18n(`entities.botFlow.fields.${name}`);
}

function enumeratorLabel(name, value) {
  return i18n(`entities.botFlow.enumerators.${name}.${value}`);
}

const fields = {
  id: new IdField('id', label('id')),
  name: new StringField('name', label('name'), {
    required: true,
    min: 2,
    max: 255,
  }),
  phoneNumberId: new StringField(
    'phoneNumberId',
    label('phoneNumberId'),
    {
      required: true,
      min: 2,
      max: 255,
    }
  ),
  phoneNumber: new StringField(
    'phoneNumber',
    label('phoneNumber'),
    {
      required: false,
      min: 2,
      max: 255,
    }
  ),
  accessToken: new StringField(
    'accessToken',
    label('accessToken'),
    {
      required: true,
      min: 2,
      max: 255,
    }
  ),
  messages:  new JsonField('messages', label('messages')),
  termsUrl: new StringField('termsUrl', label('termsUrl'), {
    required: false,
    max: 500,
  }),
  type: new EnumeratorField(
    'type',
    label('type'),
    [
      { id: 'hourlyBooking', label: enumeratorLabel('type', 'hourlyBooking') },
      { id: 'periodBooking', label: enumeratorLabel('type', 'periodBooking') },
      { id: 'buildingBooking', label: enumeratorLabel('type', 'buildingBooking') },
      { id: 'clubBooking', label: enumeratorLabel('type', 'clubBooking') },
      { id: 'logisticSupport', label: enumeratorLabel('type', 'logisticSupport') },
    ],
    'single',
    { required: true },
  ),
  createdAt: new DateTimeField(
    'createdAt',
    label('createdAt'),
  ),
  updatedAt: new DateTimeField(
    'updatedAt',
    label('updatedAt'),
  ),
  createdAtRange: new DateTimeRangeField(
    'createdAtRange',
    label('createdAtRange'),
  ),
  user: new RelationToOneField('user', label('user'), {
    required: true,
  })
};

export default {
  fields,
};
